// extracted by mini-css-extract-plugin
module.exports = {"job-help-text":"jobs_tab_content__job-help-text___kSK8Y","jobHelpText":"jobs_tab_content__job-help-text___kSK8Y"};